import React from 'react';

import zenM from '../../images/Zenmentum.png';
import zenM2 from '../../images/zenmentum3.png';
import nw from '../../images/N-W.png';
import bb from '../../images/bbounty2.png';
import sReader from '../../images/SightreaderLogo.png';
import translator from '../../images/translator.png';
import geoExp from '../../images/GeoExp.png';

import {
  bandBountyDesc,
  sightReaderDesc,
  translatorDesc,
  zenmentumDesc,
  geoExpDesc,
  noteWarr,
} from './projectDescription';

import ts from '../../images/tagsvg/ts.svg';
import sass from '../../images/tagsvg/sass.svg';
import next from '../../images/tagsvg/next.svg';
import mongo from '../../images/tagsvg/mongo.svg';
import express from '../../images/tagsvg/express.svg';
import reactTag from '../../images/tagsvg/react.svg';
import reduxTag from '../../images/tagsvg/redux.svg';
import firebase from '../../images/tagsvg/firebase.svg';
import tailwind from '../../images/tagsvg/tailwind.svg';
import particle from '../../images/tagsvg/particle.svg';
import sui from '../../images/tagsvg/sui.svg';
import chart from '../../images/tagsvg/chart.svg';
import axiosTag from '../../images/tagsvg/axios.svg';
import gta from '../../images/tagsvg/translate.svg';
import jest from '../../images/tagsvg/jestTag.svg';
import cypress from '../../images/tagsvg/cypressTag.svg';

const MobileContent = () => {
  return (
    <div className="mobileContent">
      <div id="red" className="mobilePhoto">
        <img id="red-img" src={nw} alt="testimage" />
      </div>
      <div className="mobile-title">
        <h1>Note-Warriors</h1>
      </div>
      <div>
        <ul className="tag-list">
          <li className="tag-flex">
            <img className="tag-svg" src={ts} alt="ts logo" />
            Typescript
          </li>
          <li className="tag-flex">
            <img className="tag-svg" src={tailwind} alt="tailwind logo" />
            Tailwind
          </li>
          <li className="tag-flex">
            <img className="tag-svg" src={next} alt="mongodb logo" />
            Next
          </li>
          {/* <li className="tag-flex">
            <img className="tag-svg" src={express} alt="express logo" />
            ExpressJs
          </li>
          <li className="tag-flex">
            <img className="tag-svg" src={reactTag} alt="react logo" />
            React
          </li> */}
        </ul>
      </div>

      <p className="desc-p">{noteWarr}</p>

      <div className="button-section">
        <a
          href="https://note-warriors-danboyce92.vercel.app/"
          className="live-button"
        >
          Live Project
        </a>
        <a
          href="https://github.com/danboyce92/note-warriors-next"
          className="repo-button"
        >
          Github Repo
        </a>
      </div>

      <div id="green" className="mobilePhoto">
        <img id="green-img" src={zenM2} alt="testImage2" />
      </div>
      <div className="mobile-title">
        <h1>ZenMentum</h1>
      </div>
      <div>
        <ul className="tag-list">
          <li className="tag-flex">
            <img className="tag-svg" src={ts} alt="react logo" />
            Typescript
          </li>
          <li className="tag-flex">
            <img className="tag-svg" src={sass} alt="redux logo" />
            Sass
          </li>
          <li className="tag-flex">
            <img className="tag-svg" src={mongo} alt="firebase logo" />
            MongoDb
          </li>
          <li className="tag-flex">
            <img className="tag-svg" src={express} alt="tailwind logo" />
            Express
          </li>
          <li className="tag-flex">
            <img className="tag-svg" src={reactTag} alt="particle logo" />
            React
          </li>
        </ul>
      </div>

      <p className="desc-p">{zenmentumDesc}</p>

      <div className="button-section">
        <a
          href="https://zenmentum-front.vercel.app/"
          className="live-button triple"
        >
          Live Project
        </a>
        <a
          href="https://github.com/danboyce92/Productivity-Tracker-App"
          className="repo-button triple"
        >
          Github Repo
        </a>
      </div>

      <div id="pink" className="mobilePhoto">
        <img id="pink-img" src={bb} alt="testImage2" />
      </div>
      <div className="mobile-title">
        <h1>Band-Bounty</h1>
      </div>
      <div>
        <ul className="tag-list">
          <li className="tag-flex">
            <img className="tag-svg" src={reactTag} alt="react logo" />
            React
          </li>
          <li className="tag-flex">
            <img className="tag-svg" src={reduxTag} alt="redux logo" />
            Redux
          </li>
          <li className="tag-flex">
            <img className="tag-svg" src={firebase} alt="firebase logo" />
            Firebase
          </li>
          <li className="tag-flex">
            <img className="tag-svg" src={tailwind} alt="tailwind logo" />
            Tailwind
          </li>
          <li className="tag-flex">
            <img className="tag-svg" src={particle} alt="particle logo" />
            ParticleJs
          </li>
        </ul>
      </div>

      <p className="desc-p">{bandBountyDesc}</p>

      <div className="button-section">
        <a
          href="https://band-bounty.vercel.app/"
          className="live-button triple"
        >
          Live Project
        </a>
        <a
          href="https://github.com/danboyce92/Band-Bounty-Mockup"
          className="repo-button triple"
        >
          Github Repo
        </a>
        <a
          href="https://github.com/danboyce92/BandBountyRebuild"
          className="repo-button triple"
        >
          Smart Contract
        </a>
      </div>

      <div id="blue" className="mobilePhoto">
        <img id="translator-img" src={geoExp} alt="translator " />
      </div>
      <div className="mobile-title">
        <h1>Geo-Explorer</h1>
      </div>
      <div>
        <ul className="tag-list">
          <li className="tag-flex">
            <img className="tag-svg" src={reactTag} alt="react logo" />
            React
          </li>
          <li className="tag-flex">
            <img className="tag-svg" src={reduxTag} alt="redux logo" />
            Redux-Toolkit
          </li>
          <li className="tag-flex">
            <img className="tag-svg" src={jest} alt="tailwind logo" />
            Jest
          </li>
          <li className="tag-flex">
            <img className="tag-svg" src={cypress} alt="chart logo" />
            Cypress
          </li>
          <li className="tag-flex">
            <img
              className="tag-svg"
              src={axiosTag}
              alt="google translate logo"
            />
            Axios
          </li>
        </ul>
      </div>
      <p className="desc-p">{geoExpDesc}</p>

      <div className="button-section last">
        <a
          href="https://geo-explorer-henna.vercel.app/"
          className="live-button"
        >
          Live Project
        </a>
        <a
          href="https://github.com/danboyce92/GeoExplorer"
          className="repo-button"
        >
          Github Repo
        </a>
      </div>
    </div>
  );
};

export default MobileContent;
